/* eslint-disable @typescript-eslint/no-explicit-any */
import { cloneElement, Children, useRef, useEffect } from 'react';

const useOutsideClick = (ref: any, callback: () => void, isActive = true) => {
  useEffect(() => {
    const handleOutsideClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target)) {
        callback();
      }
    };

    if (isActive) document.addEventListener('mousedown', handleOutsideClick);
    else document.removeEventListener('mousedown', handleOutsideClick);

    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, [ref, isActive, callback]);
};

interface OutsideClickHandlerProps {
  isActive: boolean;
  callback: () => void;
  children: any;
}
const OutsideClickHandler = ({ isActive = true, callback, children }: OutsideClickHandlerProps) => {
  const ref = useRef(null);
  useOutsideClick(ref, callback, isActive);
  return Children.map(children, (child) => cloneElement(child, { ref }));
};

export default OutsideClickHandler;
